import { Phone, Mail, MapPin } from "lucide-react";
import { PageShell, PageHero } from "@/components/PageShell";
import { Reveal } from "@/components/Reveal";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, ZONE } from "@/lib/constants";

const Block = ({ title, testid, children }) => (
  <Reveal>
    <div data-testid={testid} className="border-b border-[#EDEAE3] py-8 first:pt-0 last:border-none">
      <h2 className="font-display text-xl font-medium text-navy sm:text-2xl">{title}</h2>
      <div className="mt-4 space-y-2 text-sm leading-relaxed text-stone-500 sm:text-base">{children}</div>
    </div>
  </Reveal>
);

export default function MentionsLegalesPage() {
  return (
    <PageShell>
      <PageHero
        testid="page-mentions-legales-hero"
        label="Informations légales"
        title="Mentions légales"
        sub="Informations relatives à l'éditeur du site CozyHome, conformément à la législation en vigueur."
      />

      <section className="bg-ivory pb-20 sm:pb-28">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Block title="Éditeur du site" testid="mentions-editeur">
            <p><b className="text-navy">PME COZYHOME</b></p>
            <p>SASU au capital de 150 €</p>
            <p>Siège social : 47 rue Vivienne, 75002 Paris</p>
            <p>SIREN : 103 556 882</p>
            <p>SIRET : 103 556 882 00019</p>
            <p>RCS Paris</p>
            <p>TVA intracommunautaire : FR28 103556882</p>
            <p>Directeur de la publication : Philippe Mendes Evaristo, Président.</p>
            <p>Site : www.pmecozyhome.com</p>
          </Block>

          <Block title="Contact" testid="mentions-contact">
            <a data-testid="mentions-phone" href={PHONE_TEL} className="flex items-center gap-3 transition-colors duration-300 hover:text-cognac">
              <Phone className="h-4 w-4 shrink-0 text-cognac" /> {PHONE_DISPLAY}
            </a>
            <a data-testid="mentions-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 transition-colors duration-300 hover:text-cognac">
              <Mail className="h-4 w-4 shrink-0 text-cognac" /> {EMAIL}
            </a>
            <p data-testid="mentions-zone" className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-cognac" /> Zone d'intervention : {ZONE}
            </p>
          </Block>

          <Block title="Hébergement" testid="mentions-hebergement">
            <p><b className="text-navy">Emergent Labs Inc.</b></p>
            <p>255 California Street, Suite 550, San Francisco, CA 94111, États-Unis</p>
            <p>Contact hébergeur : support@emergent.sh</p>
          </Block>
        </div>
      </section>
    </PageShell>
  );
}
